// Strings of the correction pass of 29 Oct 2026: account selectors, tax on expenses, price and below-cost controls,
// the compact register and home, the sidebar. Arabic marked "new" needs review by an Arabic copy editor.
export const PASS29_STRINGS: Record<"en" | "ar", Record<string, string>> = {
  en: {
    accSearchPh: "Search by code, name or group",
    accGroupNoEntries: "A group: takes no entries. Add a posting account beneath it in the chart.",
    accGroupNotPostable: "This is a group, which only totals the accounts beneath it. Choose a posting account.",
    expTax: "Tax",
    expNoTax: "No tax",
    expAmountEntered: "Amount",
    expTaxMode: "The amount",
    expExclusive: "Excludes tax",
    expInclusive: "Includes tax",
    expRecoverable: "Tax treatment",
    expRecYes: "Recoverable input tax (posted to {a})",
    expRecShort: "Recoverable",
    expRecNo: "Not recoverable (part of the expense)",
    expRecHint: "Whether this tax can be reclaimed is your accounting decision; Delta does not assume it.",
    expBeforeTax: "Before tax",
    expTaxAmount: "Tax ({r} %)",
    expTotalInclTax: "Total including tax",
    expTaxTotal: "The treasuries must add up to the total including tax, {x}.",
    expTaxTotalShort: "The treasuries must add up to the total including tax.",
    rpExpenseVat: "Recoverable tax on expenses",
    errExpenseTaxChanged: "This expense's tax type changed after it was saved. Open it, check the amounts and save it again before posting.",
    errPriceEdit: "Changing a selling price needs the right to edit prices. Keep the list price, or ask a user who may change prices.",
    listPriceMissing: "This unit has no list price here: only a user who may change prices can set one.",
    customerPricingUnset: "This customer came from the old system without a pricing level. Set its pricing level on the customer first, then sell to it.",
    nameEnMissing: "No English name yet",
    nameArMissing: "No Arabic name yet",
    priceLocked: "List price: you may not change selling prices",
    priceFromList: "List price {p}; set by {u}",
    bcTitle: "Sale below cost",
    bcRequired: "Some lines are below the stock's cost after discounts, before VAT. The sale needs an approval from another user who may approve sales below cost.",
    bcInvalid: "The approval cannot be used (not given, refused, expired, or another user's). Ask for a new approval.",
    bcUsed: "This approval has already been used for a sale. Ask for a new approval.",
    bcSelf: "Nobody can approve their own sale below cost. Another user who may approve sales below cost must approve it.",
    bcChanged: "The sale or the stock's cost has changed since it was approved. Ask for a new approval.",
    bcLine: "Line",
    bcValue: "Value before VAT",
    bcCost: "Cost",
    bcCostHidden: "Hidden",
    bcReason: "Reason for approving",
    bcReasonHint: "Kept in the audit log with your name and the time.",
    bcAsk: "Ask for approval",
    bcWaiting: "Waiting for approval. An approver sees this request in Sales › Price controls. You can keep this window open, or close it: the sale goes back to the original price and the request stays open.",
    bcApprovedBy: "Approved by {u}: {r}",
    bcContinue: "Continue with the approval",
    bcRejected: "The request was refused by {u}.",
    bcAskFailed: "The approval could not be requested.",
    bcListPrice: "Original price",
    bcProposedPrice: "Proposed price",
    bcFee: "Tobacco fee",
    bcProposedTotal: "Proposed total",
    bcProposalOpen: "Whole sale as proposed: {x}",
    posPriceNotApprovedRestored: "The price change was not approved, so the original price was restored ({items}). You can complete the sale at this price.",
    posPricePendingRestored: "The price change is not approved yet, so the original price was restored ({items}). The request stays open: when it is approved, use it from the cart.",
    posPriceNotAllowedRestored: "You may not change this price, so the original price was restored ({items}).",
    posProposal_pending: "Price request waiting for approval. Proposed total {x}.",
    posProposal_approved: "Price request approved by {u}. Proposed total {x}.",
    posProposal_rejected: "Price request refused by {u}. The cart keeps the original price.",
    posProposal_used: "Price request used.",
    posProposalDetails: "Proposed sale",
    posProposalApply: "Use approved price",
    posProposalHide: "Hide",
    posProposalChanged: "The sale has changed since the request (items, quantities, discounts, customer or warehouse). Ask for a new approval.",
    posProposalApplied: "The price approved by {u} is in the cart. Complete the sale to use the approval.",
    posCustomerNoPricing: "This customer has no price list yet. Set it on the customer first, then sell to them.",
    pcTitle: "Price controls",
    pcSub: "Who may change selling prices, approve sales below cost and see costs. Separate rights: none implies another.",
    pcEditPrice: "Change selling prices",
    pcApprove: "Approve sales below cost",
    pcViewCost: "See costs",
    pcOwner: "Business owner: every right",
    pcOwnerOnly: "Only the business owner grants or takes back these rights.",
    pcRequests: "Below-cost approvals",
    pcNoRequests: "No requests.",
    pcRequestedBy: "Requested by",
    pcApproveBtn: "Approve",
    pcRejectBtn: "Refuse",
    pcStatus_pending: "Pending",
    pcStatus_approved: "Approved",
    pcStatus_rejected: "Refused",
    pcStatus_used: "Used",
    pcRejectReason: "Reason (optional)",
    pcPolicy: "How it works: a sales line is below cost when its value after line and invoice discounts, before VAT, is less than the stock's average cost for the quantity sold (in base units), compared exactly with no rounding. Stock held at a zero value has no known cost, so its sale needs an approval too. Services have no stock cost. An approval is given by another user who holds the right, never by the user who asked (the owner included). It covers one sale as it stood, for the user who asked, once, with no time limit, and only while the cost has not risen or changed between known and unknown.",
    bcCostUnknown: "Cost not known (stock held at zero value)",
    posOfflineNotCompleted: "Delta cannot be reached, so the sale was not completed and nothing was recorded. The register sells online only: price and cost checks are never left for later. Check the connection and press pay again; the same sale cannot be completed twice.",
    errBelowCost: "This sale is below the stock's cost and needs an approval.",
    posAbout: "About this register (rules and limits)",
    sbHide: "Hide menu",
    sbShow: "Show menu"
  },
  ar: {
    accSearchPh: "ابحث بالرمز أو الاسم أو المجموعة", // new
    accGroupNoEntries: "مجموعة: لا تقبل قيودًا. أضف تحتها حساب ترحيل في دليل الحسابات.", // new
    accGroupNotPostable: "هذه مجموعة تجمع أرصدة الحسابات التي تحتها فقط. اختر حساب ترحيل.", // new
    expTax: "الضريبة", // new
    expNoTax: "بدون ضريبة", // new
    expAmountEntered: "المبلغ", // new
    expTaxMode: "المبلغ المدخل", // new
    expExclusive: "غير شامل الضريبة", // new
    expInclusive: "شامل الضريبة", // new
    expRecoverable: "معالجة الضريبة", // new
    expRecYes: "ضريبة مدخلات قابلة للاسترداد (تُرحَّل إلى {a})", // new
    expRecShort: "قابلة للاسترداد", // new
    expRecNo: "غير قابلة للاسترداد (جزء من المصروف)", // new
    expRecHint: "قابلية استرداد هذه الضريبة قرار محاسبي لكم؛ لا يفترضه النظام.", // new
    expBeforeTax: "قبل الضريبة", // new
    expTaxAmount: "الضريبة ({r} %)", // new
    expTotalInclTax: "الإجمالي شامل الضريبة", // new
    expTaxTotal: "يجب أن يساوي مجموع الخزائن الإجمالي شامل الضريبة، {x}.", // new
    expTaxTotalShort: "يجب أن يساوي مجموع الخزائن الإجمالي شامل الضريبة.", // new
    rpExpenseVat: "الضريبة القابلة للاسترداد على المصروفات", // new
    errExpenseTaxChanged: "تغيّر نوع ضريبة هذا المصروف بعد حفظه. افتحه وراجع المبالغ واحفظه مرة أخرى قبل الترحيل.", // new
    errPriceEdit: "تغيير سعر البيع يحتاج إلى صلاحية تعديل الأسعار. أبقِ سعر القائمة، أو اطلب ذلك من مستخدم يملك الصلاحية.", // new
    listPriceMissing: "لا يوجد سعر قائمة لهذه الوحدة هنا: لا يحدده إلا مستخدم يملك صلاحية تغيير الأسعار.", // new
    customerPricingUnset: "نُقل هذا العميل من النظام القديم دون مستوى تسعير. حدِّد مستوى تسعيره في بطاقة العميل أولًا، ثم بِع له.", // new
    nameEnMissing: "لا يوجد اسم إنجليزي بعد", // new
    nameArMissing: "لا يوجد اسم عربي بعد", // new
    priceLocked: "سعر القائمة: لا تملك صلاحية تغيير أسعار البيع", // new
    priceFromList: "سعر القائمة {p}؛ عدّله {u}", // new
    bcTitle: "بيع بأقل من التكلفة", // new
    bcRequired: "بعض البنود أقل من تكلفة المخزون بعد الخصومات وقبل الضريبة. يحتاج البيع إلى موافقة مستخدم آخر يملك صلاحية الموافقة على البيع بأقل من التكلفة.", // new
    bcInvalid: "لا يمكن استخدام هذه الموافقة (لم تُمنح، أو رُفضت، أو انتهت، أو تخص مستخدمًا آخر). اطلب موافقة جديدة.", // new
    bcUsed: "استُخدمت هذه الموافقة في عملية بيع سابقة. اطلب موافقة جديدة.", // new
    bcSelf: "لا يمكن لأحد الموافقة على بيعه بأقل من التكلفة. يجب أن يوافق عليه مستخدم آخر يملك صلاحية الموافقة على البيع بأقل من التكلفة.", // new
    bcChanged: "تغيّر البيع أو تكلفة المخزون منذ الموافقة. اطلب موافقة جديدة.", // new
    bcLine: "البند", // new
    bcValue: "القيمة قبل الضريبة", // new
    bcCost: "التكلفة", // new
    bcCostHidden: "مخفية", // new
    bcReason: "سبب الموافقة", // new
    bcReasonHint: "يُحفظ في سجل التدقيق مع اسمك والوقت.", // new
    bcAsk: "اطلب الموافقة", // new
    bcWaiting: "بانتظار الموافقة. يرى المعتمِد هذا الطلب في المبيعات › ضوابط الأسعار. يمكنك إبقاء هذه النافذة مفتوحة أو إغلاقها: يعود البيع إلى السعر الأصلي ويبقى الطلب مفتوحًا.", // new
    bcApprovedBy: "وافق {u}: {r}", // new
    bcContinue: "تابِع بالموافقة", // new
    bcRejected: "رفض {u} الطلب.", // new
    bcAskFailed: "تعذّر طلب الموافقة.", // new
    bcListPrice: "السعر الأصلي", // new
    bcProposedPrice: "السعر المقترح", // new
    bcFee: "رسوم التبغ", // new
    bcProposedTotal: "الإجمالي المقترح", // new
    bcProposalOpen: "البيع كاملًا كما اقتُرح: {x}", // new
    posPriceNotApprovedRestored: "لم تتم الموافقة على تغيير السعر، فأُعيد السعر الأصلي ({items}). يمكنك إتمام البيع بهذا السعر.", // new
    posPricePendingRestored: "لم تتم الموافقة على تغيير السعر بعد، فأُعيد السعر الأصلي ({items}). يبقى الطلب مفتوحًا: عند الموافقة استخدمه من السلة.", // new
    posPriceNotAllowedRestored: "لا تملك صلاحية تغيير هذا السعر، فأُعيد السعر الأصلي ({items}).", // new
    posProposal_pending: "طلب السعر بانتظار الموافقة. الإجمالي المقترح {x}.", // new
    posProposal_approved: "وافق {u} على طلب السعر. الإجمالي المقترح {x}.", // new
    posProposal_rejected: "رفض {u} طلب السعر. تبقى السلة بالسعر الأصلي.", // new
    posProposal_used: "استُخدم طلب السعر.", // new
    posProposalDetails: "البيع المقترح", // new
    posProposalApply: "استخدام السعر المعتمد", // new
    posProposalHide: "إخفاء", // new
    posProposalChanged: "تغيّر البيع منذ الطلب (الأصناف أو الكميات أو الخصومات أو العميل أو المستودع). اطلب موافقة جديدة.", // new
    posProposalApplied: "السعر الذي وافق عليه {u} في السلة. أتمّ البيع لاستخدام الموافقة.", // new
    posCustomerNoPricing: "لا توجد قائمة أسعار لهذا العميل بعد. حدِّدها في بطاقة العميل أولًا، ثم بِع له.", // new
    pcTitle: "ضوابط الأسعار", // new
    pcSub: "من يمكنه تغيير أسعار البيع، والموافقة على البيع بأقل من التكلفة، ورؤية التكاليف. صلاحيات منفصلة لا تتضمن إحداها الأخرى.", // new
    pcEditPrice: "تغيير أسعار البيع", // new
    pcApprove: "الموافقة على البيع بأقل من التكلفة", // new
    pcViewCost: "رؤية التكاليف", // new
    pcOwner: "مالك النشاط: كل الصلاحيات", // new
    pcOwnerOnly: "يمنح مالك النشاط وحده هذه الصلاحيات أو يسحبها.", // new
    pcRequests: "موافقات البيع بأقل من التكلفة", // new
    pcNoRequests: "لا توجد طلبات.", // new
    pcRequestedBy: "طلبه", // new
    pcApproveBtn: "موافقة", // new
    pcRejectBtn: "رفض", // new
    pcStatus_pending: "قيد الانتظار", // new
    pcStatus_approved: "تمت الموافقة", // new
    pcStatus_rejected: "مرفوض", // new
    pcStatus_used: "مستخدمة", // new
    pcRejectReason: "السبب (اختياري)", // new
    pcPolicy: "آلية العمل: يكون بند البيع أقل من التكلفة عندما تكون قيمته بعد خصم البند وخصم الفاتورة، وقبل الضريبة، أقل من متوسط تكلفة المخزون للكمية المباعة (بالوحدة الأساسية)، وتتم المقارنة بدقة دون تقريب. المخزون المسجل بقيمة صفر تكلفته غير معروفة، فيحتاج بيعه إلى موافقة أيضًا. الخدمات ليست لها تكلفة مخزون. يمنح الموافقةَ مستخدمٌ آخر يملك الصلاحية، ولا يمنحها أبدًا المستخدم الذي طلبها (ولا المالك). تغطي الموافقة بيعًا واحدًا كما كان، للمستخدم الذي طلبها، مرة واحدة، دون مدة محددة، وما دامت التكلفة لم ترتفع ولم تتحول بين معروفة وغير معروفة.", // new
    bcCostUnknown: "التكلفة غير معروفة (مخزون بقيمة صفر)", // new
    posOfflineNotCompleted: "تعذر الوصول إلى دلتا، لذلك لم يكتمل البيع ولم يُسجَّل شيء. نقطة البيع تعمل متصلة فقط: لا تؤجَّل فحوص السعر والتكلفة. تحقق من الاتصال ثم اضغط الدفع مرة أخرى؛ لا يمكن إتمام البيع نفسه مرتين.", // new
    errBelowCost: "هذا البيع أقل من تكلفة المخزون ويحتاج إلى موافقة.", // new
    posAbout: "عن نقطة البيع هذه (القواعد والحدود)", // new
    sbHide: "إخفاء القائمة", // new
    sbShow: "إظهار القائمة" // new
  }
};
